import StoreContainer from "./StoreContainer";
import { VisitorBotMessageType, ActionPopoverContent } from "../types";
import { EventEmitter } from "events";

//Less of a store, but instead will contain the logic for every type of action card/popover action.
class ActionCardStore {
  private _emitter = new EventEmitter();

  onReceiveActionPopoverContent(
    callback: (content: ActionPopoverContent) => void
  ) {
    this._emitter.addListener("receiveActionPopoverContent", callback);
  }

  async handleCardAction(actionName: string, actionData: string) {
    switch (actionName) {
      case "calendly_book":
        await this.handleCalendlyBook(actionData);
        break;
      case "calendly_skip":
        await this.handleCalendlySkip();
        break;
    }
  }

  private async handleCalendlyBook(calenderName: string) {
    const onBookMeeting = async () => {
      const bookedPathId =
        StoreContainer.BotStore.getCalendlyResult().BookedPathId;
      if (!bookedPathId) {
        return;
      }
      StoreContainer.BotStore.clearCalendlyResult();
      await StoreContainer.ChatStore.sendBotMessage(
        VisitorBotMessageType.BookedMeeting,
        null,
        bookedPathId
      );
    };

    const content: ActionPopoverContent = {
      type: "calendly",
      data: {
        calenderName: calenderName,
        onBookMeeting: onBookMeeting
      }
    };
    this._emitter.emit("receiveActionPopoverContent", content);
  }

  private async handleCalendlySkip() {
    const skippedPathId =
      StoreContainer.BotStore.getCalendlyResult().SkippedPathId;
    if (!skippedPathId) {
      return;
    }
    StoreContainer.BotStore.clearCalendlyResult();
    StoreContainer.ChatStore.emitMessagesChange(); //Trigers an update to clear the skip button
    await StoreContainer.ChatStore.sendBotMessage(
      VisitorBotMessageType.Progress,
      "Skip",
      skippedPathId
    );
  }
}

export default ActionCardStore;
